import { Component, ChangeDetectionStrategy, inject, computed, input, output } from '@angular/core';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { NgStyle } from '@angular/common';
import { SplicedBackgroundComponent } from '../../surface/spliced-background/spliced-background.component';
import { IconComponent } from '../../icon/icon/icon.component';
import { ThemeService } from '../../../core/services/theme/theme.service';

@Component({
  selector: 'app-tab-button',
  templateUrl: './tab-button.component.html',
  styleUrls: ['./tab-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe, SplicedBackgroundComponent, IconComponent],
})
export class TabButtonComponent {
  private themeService = inject(ThemeService);
  protected readonly splicedBg = computed(() =>
    this.themeService.splicedBackgroundPlacement(
      'tab-button',
      this.isSelected() ? 'selected' : 'unselected',
    ),
  );

  readonly label = input.required<string>();
  readonly isSelected = input(true);
  readonly pendingCount = input<number | null>(null);
  readonly showDot = input(false);
  readonly clickEvent = output<void>();

  get tabStyles(): [string, string][] {
    const key = `tab-${this.isSelected() ? 'selected' : 'unselected'}`;
    return [
      ['type', `${key}-label`],
      ['text-color', `${key}-label`],
      ['border-radius', key],
      ['drop-and-inner-shadow', key],
      ['height', 'tab'],
    ];
  }

  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.clickEvent.emit();
  }
}
